<template >
  <div id="quicklyStorage" class="page-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>爬虫执行情况</el-breadcrumb-item>
      <el-breadcrumb-item>快速入库</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <el-row class="executionPage">
        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            快速入库执行情况概览
          </div>
          <div style="width: 100%;height: 120px;" v-loading="echLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <div style="width: 20%;float: left;" v-for="item in quicklyData">
              <div class="fontDiv">
                <div class="fontColor">
                  {{item.name}}
                </div>
                <div class="numStyle">
                  {{item.num}}
                </div>
              </div>
            </div>
          </div>
          <el-row>
            <el-col :span="24">
              <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
                <div class="iconDiv">
                  .
                </div>
                近24小时各平台快速入库执行情况
              </div>
              <div class="fontDiv2" v-loading="echLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
                <el-col :span="24">
                  <el-radio-group v-model="checkboxGroup" size="mini" @change="dataChange">
                    <el-radio-button v-for="item in platForm" :label="item.name" :key="item.calue"></el-radio-button>
                  </el-radio-group>
                </el-col>

                <div style="width: calc(100% + 20px);">
                  <div style="width: 20%;float: left;" v-for="(item,index) in ecquickData">
                    <div class="colDiv">
                      <div class="fontColor">
                        {{item.name}}
                      </div>
                      <div class="numStyle">
                        {{item.num}}
                      </div>
                    </div>
                  </div>
                </div>

                <el-col :span="24">
                  <div id="chartLineBox" style="width: 100%;height: 400px;"> </div>
                </el-col>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  export default {
    data(){
      return{
        echLoading: false,
        quicklyData: [{
          num: 0,
          name: '待获取',
        },{
          num: 0,
          name: '获取中',
        },{
          num: 0,
          name: '链接失效或下架',
        },{
          num: 0,
          name: '数据获取异常',
        },{
          num: 0,
          name: '已获取',
        }],
        ecquickData: [{
          num: 0,
          name: '待获取',
        },{
          num: 0,
          name: '获取中',
        },{
          num: 0,
          name: '链接失效或下架',
        },{
          num: 0,
          name: '数据获取异常',
        },{
          num: 0,
          name: '已获取',
        }],
        getbycount:[],
        todayNum: 0,
        checkboxGroup: '淘宝',
        platForm: [{
          name: '淘宝',
          calue: 'TB'
        },{
          name: '天猫',
          calue: 'TM'
        },{
          name: '京东',
          calue: 'JD'
        },{
          name: '苏宁',
          calue: 'SN'
        },{
          name: '1688',
          calue: 'p1688'
        },{
          name: '当当',
          calue: 'DD'
        }]
      }
    },
    mounted() {
      this.getOverviewByfastStockIn()
    },
    methods:{
      getOverviewByfastStockIn() {
        this.echLoading = true
        fetch({
          url: "hcm/iprNewPluginList/getOverviewByfastStockIn",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            
            this.getbycount = []
            this.getbycount = res.data
            if (res.data.status0) {
              this.quicklyData[0].num = res.data.status0
            }
            if (res.data.status1) {
              this.quicklyData[1].num = res.data.status1
            }
            if (res.data.status2) {
              this.quicklyData[2].num = res.data.status2
            }
            if (res.data.status3) {
              this.quicklyData[3].num = res.data.status3
            }
            if (res.data.status4) {
              this.quicklyData[4].num = res.data.status4
            }
            this.dataChange()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      dataChange() {
        let createtime = []
        let updatefailure = []
        let updatesucceed = []
        createtime = this.getbycount.xAxis
        if (this.checkboxGroup == '淘宝' && this.getbycount.TB) {
          for (let t in this.getbycount.TB.series) {
            if (this.getbycount.TB.series[t].name == '异常条数') {
              updatefailure = this.getbycount.TB.series[t].data
            }
            if (this.getbycount.TB.series[t].name == '成功条数') {
              updatesucceed = this.getbycount.TB.series[t].data
            }
          }
          this.ecquickData[0].num = this.getbycount.TB.status0
          this.ecquickData[1].num = this.getbycount.TB.status1
          this.ecquickData[2].num = this.getbycount.TB.status2
          this.ecquickData[3].num = this.getbycount.TB.status3
          this.ecquickData[4].num = this.getbycount.TB.status4
        }
        if (this.checkboxGroup == '天猫' && this.getbycount.TM) {
          for (let t in this.getbycount.TM.series) {
            if (this.getbycount.TM.series[t].name == '异常条数') {
              updatefailure = this.getbycount.TM.series[t].data
            }
            if (this.getbycount.TM.series[t].name == '成功条数') {
              updatesucceed = this.getbycount.TM.series[t].data
            }
          }
          this.ecquickData[0].num = this.getbycount.TM.status0
          this.ecquickData[1].num = this.getbycount.TM.status1
          this.ecquickData[2].num = this.getbycount.TM.status2
          this.ecquickData[3].num = this.getbycount.TM.status3
          this.ecquickData[4].num = this.getbycount.TM.status4
        }
        if (this.checkboxGroup == '京东' && this.getbycount.JD) {
          for (let t in this.getbycount.JD.series) {
            if (this.getbycount.JD.series[t].name == '异常条数') {
              updatefailure = this.getbycount.JD.series[t].data
            }
            if (this.getbycount.JD.series[t].name == '成功条数') {
              updatesucceed = this.getbycount.JD.series[t].data
            }
          }
          this.ecquickData[0].num = this.getbycount.JD.status0
          this.ecquickData[1].num = this.getbycount.JD.status1
          this.ecquickData[2].num = this.getbycount.JD.status2
          this.ecquickData[3].num = this.getbycount.JD.status3
          this.ecquickData[4].num = this.getbycount.JD.status4
        }
        if (this.checkboxGroup == '1688' && this.getbycount.p1688) {
          for (let t in this.getbycount.p1688.series) {
            if (this.getbycount.p1688.series[t].name == '异常条数') {
              updatefailure = this.getbycount.p1688.series[t].data
            }
            if (this.getbycount.p1688.series[t].name == '成功条数') {
              updatesucceed = this.getbycount.p1688.series[t].data
            }
          }
          this.ecquickData[0].num = this.getbycount.p1688.status0
          this.ecquickData[1].num = this.getbycount.p1688.status1
          this.ecquickData[2].num = this.getbycount.p1688.status2
          this.ecquickData[3].num = this.getbycount.p1688.status3
          this.ecquickData[4].num = this.getbycount.p1688.status4
        }
        if (this.checkboxGroup == '当当' && this.getbycount.DD && this.getbycount.DD.series) {
          for (let t in this.getbycount.DD.series) {
            if (this.getbycount.DD.series[t].name == '异常条数') {
              updatefailure = this.getbycount.DD.series[t].data
            }
            if (this.getbycount.DD.series[t].name == '成功条数') {
              updatesucceed = this.getbycount.DD.series[t].data
            }
          }
          this.ecquickData[0].num = this.getbycount.DD.status0
          this.ecquickData[1].num = this.getbycount.DD.status1
          this.ecquickData[2].num = this.getbycount.DD.status2
          this.ecquickData[3].num = this.getbycount.DD.status3
          this.ecquickData[4].num = this.getbycount.DD.status4
        }
        if (this.checkboxGroup == '苏宁' && this.getbycount.SN && this.getbycount.SN.series) {
          for (let t in this.getbycount.SN.series) {
            if (this.getbycount.SN.series[t].name == '异常条数') {
              updatefailure = this.getbycount.SN.series[t].data
            }
            if (this.getbycount.SN.series[t].name == '成功条数') {
              updatesucceed = this.getbycount.SN.series[t].data
            }
          }
          this.ecquickData[0].num = this.getbycount.SN.status0
          this.ecquickData[1].num = this.getbycount.SN.status1
          this.ecquickData[2].num = this.getbycount.SN.status2
          this.ecquickData[3].num = this.getbycount.SN.status3
          this.ecquickData[4].num = this.getbycount.SN.status4
        }
        this.echLoading = false
        this.echartsLine(createtime,updatefailure,updatesucceed)
      },
      // echarts表格展示
      echartsLine(createtime,updatefailure,updatesucceed) {
        this.chartLine = echarts.init(document.getElementById('chartLineBox'));
        // 指定图表的配置项和数据
        var option = {
            tooltip: {              //设置tip提示
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {               //设置区分（哪条线属于什么）
              data:['成功条数','异常条数']
            },
            color: ['#1890ff', '#f04864'],       //设置区分（每条线是什么颜色，和 legend 一一对应）
            xAxis: {                //设置x轴
              type: 'category',
              // boundaryGap: false,     //坐标轴两边不留白
              data: createtime,
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '成功条数',
                data:  updatesucceed,
                type: 'bar',
                barStyle: {                // 线条样式 => 必须使用normal属性
                  normal: {
                    color: '#1890ff',
                  }
                },
              },
              {
                name: '异常条数',
                data: updatefailure,
                type: 'bar',
                barStyle: {
                  normal: {
                    color: '#f04864',
                  }
                },
              }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine.setOption(option);
      },
    }
  }
</script>

<style lang="scss">
  #quicklyStorage{
    .executionPage {
      margin: 20px;
      .iconDiv {
        width: 5px;
        background-color: #333333;
        margin-right: 10px;
        height: 21px;
        margin-top: 4px;
      }
      .fontDiv {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        margin-right: 20px;
        height: 80px;
        margin-bottom: 20px;
      }
      .fontDiv2 {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        margin-right: 20px;
        height: 520px;
        margin-bottom: 20px;
      }
      .colDiv {
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        height: 80px;
        margin-bottom: 20px;
        margin-right: 20px;
        margin: 20px 0 20px 0;
      }
      .fontColor {
        color: #00000072;
      }
      .numStyle {
        color: #1e1e1e;
        font-size: 24px;
        margin-top: 20px;
      }
    }
  }
</style>
